export default "__VITE_ASSET__DY606lPK__"